import { forwardRef } from 'react';
import IconBase from '../IconBase';
import { Icon } from '../types';

const Employee: Icon = forwardRef((props, ref) => (
  <IconBase viewBoxBase={780} ref={ref} {...props}>
    <path d='m255 570c-74.44 0-135-60.56-135-135s60.56-135 135-135 135 60.56 135 135-60.56 135-135 135zm0-240c-57.9 0-105 47.1-105 105s47.1 105 105 105 105-47.1 105-105-47.1-105-105-105z' />
    <path d='m525 330c-74.44 0-135-60.56-135-135s60.56-135 135-135 135 60.56 135 135-60.56 135-135 135zm0-240c-57.9 0-105 47.1-105 105s47.1 105 105 105 105-47.1 105-105-47.1-105-105-105z' />
    <path d='m480 720h-30c0-82.71-87.48-150-195-150s-195 67.29-195 150h-30c0-48.77 23.88-94.4 67.24-128.47 42.29-33.23 98.32-51.53 157.76-51.53s115.46 18.3 157.76 51.53c43.36 34.07 67.24 79.69 67.24 128.47z' />
    <path d='m750 480h-30c0-82.71-87.48-150-195-150-40.69 0-79.69 9.59-112.79 27.73l-14.42-26.31c37.51-20.56 81.49-31.42 127.21-31.42 59.44 0 115.46 18.3 157.76 51.53 43.36 34.07 67.24 79.69 67.24 128.47z' />
  </IconBase>
));

Employee.displayName = 'Employee';

export default Employee;
